import styled from "styled-components";

export const FileName = styled.span`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	min-width: 0;
	font-size: 0.8rem;
`;

export const FileExtension = styled.span`
	flex-shrink: 0;
	white-space: nowrap;
	font-size: 0.8rem;
`;

export const Container = styled.span<{
	isBold?: boolean;
	justifyContent?: "flex-end" | "flex-start";
}>`
	font-size: 0.8rem;
	font-weight: ${({ isBold }) => (isBold ? "bold" : "normal")};
	color: ${({ theme }) => theme.pantoneBlack};
	width: 100%;
	margin: 0 0.4rem 0 0;
	display: flex;
	align-items: center;
	justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
	min-width: 0;
	gap: 0;
`;

export const TextEllipsis = styled.span`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	min-width: 0;
	font-size: 0.8rem;
`;
